import { motion } from "framer-motion";
import { Sparkles, Compass, Disc3, ShieldAlert } from "lucide-react";

const teaserPillars = [
  {
    icon: Disc3,
    title: "Neue Sound-Dimension",
    description: "Erweiterte Audio-Architektur & internationale Guest-Headliner im Anschluss an den Pilot-Event.",
    badge: "SECRET LINEUP",
  },
  {
    icon: Compass,
    title: "Unentdecktes Territorium",
    description: "Eine völlig neue Location wird enthüllt, wenn die Reise nach Chapter 01 weitergeht.",
    badge: "NEW VENUE",
  },
  {
    icon: Sparkles,
    title: "Immersive Visuals",
    description: "Licht- & Laser-Installationen der nächsten Generation für eine unvergleichliche Nacht.",
    badge: "NEXT LEVEL",
  },
];

export const NextChapter = () => {
  return (
    <section data-testid="next-chapter-section" className="relative overflow-hidden px-5 py-28 sm:px-8">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#E5C378]/10 blur-[140px]" />
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-[2.5rem] border border-[#E5C378]/30 bg-[#13131A]/90 p-8 shadow-2xl backdrop-blur-2xl sm:p-14 lg:p-20"
        >
          <div className="absolute -right-20 -top-20 h-80 w-80 rounded-full bg-[#E5C378]/15 blur-3xl" />
          <div className="relative z-10 mx-auto max-w-3xl text-center">
            <div data-testid="next-chapter-eyebrow" className="inline-flex items-center gap-2 rounded-full border border-[#E5C378]/30 bg-[#E5C378]/10 px-4 py-1.5 font-mono text-xs font-semibold uppercase tracking-[0.28em] text-[#E5C378]">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#E5C378] opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#E5C378]" />
              </span>
              Chapter 02 • In Vorbereitung
            </div>
            <h2 data-testid="next-chapter-title" className="mt-6 font-syne text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
              Das nächste Kapitel — <span className="bg-gradient-to-r from-[#E5C378] via-[#FFF5D6] to-[#E5C378] bg-clip-text text-transparent">Coming Soon</span>
            </h2>
            <p data-testid="next-chapter-description" className="mt-6 text-base leading-relaxed text-zinc-300 sm:text-lg">
              Nach der exklusiven Vyora Pilot Series am <strong className="text-[#E5C378]">03.10.2026</strong> beginnt die nächste Stufe unserer Reise. Noch intensiver, noch exklusiver.
            </p>
          </div>
          <div className="mt-16 grid gap-6 md:grid-cols-3">
            {teaserPillars.map((pillar, index) => {
              const Icon = pillar.icon;
              return (
                <motion.div
                  key={pillar.title}
                  data-testid={`next-chapter-pillar-${index}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                  className="group relative rounded-3xl border border-white/10 bg-black/40 p-6 transition-colors duration-300 hover:border-[#E5C378]/50 hover:bg-black/60"
                >
                  <div className="flex items-center justify-between">
                    <div className="grid h-12 w-12 place-items-center rounded-2xl border border-[#E5C378]/30 bg-[#E5C378]/10 text-[#E5C378]">
                      <Icon className="h-6 w-6" />
                    </div>
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#E5C378]/80">{pillar.badge}</span>
                  </div>
                  <h3 className="mt-6 font-syne text-xl font-bold text-white">{pillar.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-zinc-400">{pillar.description}</p>
                </motion.div>
              );
            })}
          </div>
          <div className="mt-12 flex items-center justify-center gap-3 border-t border-white/10 pt-8 text-center">
            <ShieldAlert className="h-4 w-4 text-[#E5C378]" />
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">
              Updates & Drops folgen auf unseren Social Channels
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
